var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Select = dynamicRequire('Select.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');

class PullOutHandle extends React.Component {

    render() {
        let selectKey = this.props.accessory.reduce((prev, accessoryItem) => {return accessoryItem.partName + prev}, '');
        return <div className="lr-casefactory-choices-options-option option clearfix">
            <Mssg __key="nc_casefactory.pullout.handles" /><br />
            <Select className="lr-style"
                    key={selectKey}
                choiceHandler={(value) => this.context.emitter.emit('rollsOrWheels', this.getPart(this.props.accessory, value))}
                active={this.props.case.WHEEL}
                options={this.getOptions()}/>
        </div>
    }

    getOptions() {
        var defaultOption = {value:'', name: resolveLanguage('nc_casefactory.no.pullout.handle')}

        return [defaultOption, ...this.props.accessory.map((accessoryItem) => {
            var label = accessoryItem.partName ? accessoryItem.partName : resolveLanguage('nc_casefactory.part.name.' + accessoryItem.articleNumber);
            return {value: accessoryItem.id, name: label};
        })];
    }

    getPart(parts, id) {
        var candidates = parts.filter((part) => {
            return part.id == id;
        });
        if (candidates.length == 1) {
            return candidates[0];
        } else {
            return null;
        }
    }
}

PullOutHandle.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = PullOutHandle;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/PullOutHandle.jsx